var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { fromLaptop } from '../../constants/breakpoints';
export var Feature = function (_a) {
    var children = _a.children, featureRef = _a.featureRef, _b = _a.isDefault, isDefault = _b === void 0 ? false : _b;
    var Wrapper = isDefault ? DefaultWrapper : FeatureWrapper;
    return _jsx(Wrapper, { ref: featureRef, children: children });
};
// --------------------------- STYLES --------------------------- //
var FeatureWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  @media (", ") {\n    align-self: flex-start;\n    position: sticky;\n    top: 20px;\n  }\n"], ["\n  width: 100%;\n\n  @media (", ") {\n    align-self: flex-start;\n    position: sticky;\n    top: 20px;\n  }\n"])), fromLaptop);
var DefaultWrapper = styled(FeatureWrapper)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media (", ") {\n    box-sizing: border-box;\n    z-index: 3;\n  }\n"], ["\n  @media (", ") {\n    box-sizing: border-box;\n    z-index: 3;\n  }\n"])), fromLaptop);
var templateObject_1, templateObject_2;
